module.exports = __webpack_public_path__ + "static/img/14000302.f903300a.png";